import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { deleteAnswer } from "../../../../redux/answers/answers.actions";
import { editAnswer } from "../../../../redux/answers/answers.actions";
import { ReactComponent as UpVote } from "../../../../assets/ArrowUpLg.svg";
import { ReactComponent as DownVote } from "../../../../assets/ArrowDownLg.svg";
import UserCard from "../../../../components/molecules/UserCard/UserCard.component";

import "./AnswerItem.styles.scss";
import censorBadWords from "../../../../utils/censorBadWords";

const AnswerItem = ({
  deleteAnswer,
  editAnswer,
  answer: { body, user_id, gravatar, id, created_at, username },
  post: { post },
  auth,
}) => {
  const [editableContent, setEditableContent] = useState(censorBadWords(body));

  const handleEditClick = () => {
    // Llama a la función editAnswer con el contenido actual del div
    console.log(editableContent);
    editAnswer(id, editableContent);
  };

  const handleContentChange = (e) => {
    // Actualiza el estado con el contenido editable
    setEditableContent(e.target.innerText);
  };

  return (
    <Fragment>
      <div className="answer-layout">
        <div className="vote-cell">
          <div className="vote-container">
            <button
              className="vote-up"
              title="This answer is useful (click again to undo)"
            >
              <UpVote className="icon" />
            </button>
            <div className="vote-count fc-black-500">0</div>
            <button
              className="vote-down"
              title="This answer is not useful (click again to undo)"
            >
              <DownVote className="icon" />
            </button>
          </div>
        </div>
        <div className="answer-item">
          {!auth.loading &&
            auth.isAuthenticated &&
            user_id === auth.user.id ? (
            <div
              className="answer-content"
              contentEditable={true}
              onBlur={handleContentChange}
              dangerouslySetInnerHTML={{ __html: editableContent }}
            />
          ) : (
            <div
              className="answer-content fc-black-800"
              dangerouslySetInnerHTML={{ __html: censorBadWords(body) }}
            ></div>
          )}

          <div className="answer-actions">
            <div className="action-btns">
              <div className="answer-menu">
                {!auth.loading &&
                  auth.isAuthenticated &&
                  user_id === auth.user.id && (
                    <Link
                      className="s-link s-link__danger"
                      style={{ paddingLeft: "4px" }}
                      title="Edit the answer"
                      onClick={handleEditClick}
                      to={`/questions/${post.id}`}
                    >
                      edit
                    </Link>
                  )}
                {!auth.loading &&
                  auth.isAuthenticated &&
                  user_id === auth.user.id && (
                    <Link
                      className="s-link s-link__danger"
                      style={{ paddingLeft: "4px" }}
                      title="Delete the answer"
                      onClick={(e) => deleteAnswer(id)}
                      to={`/questions/${post.id}`}
                    >
                      delete
                    </Link>
                  )}
              </div>
            </div>
            <UserCard
              created_at={created_at}
              user_id={user_id}
              gravatar={gravatar}
              username={username}
              dateType={"answered"}
              backgroundColor={"transparent"}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

AnswerItem.propTypes = {
  auth: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  answer: PropTypes.object.isRequired,
  deleteAnswer: PropTypes.func.isRequired,
  editAnswer: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  post: state.post,
});

export default connect(mapStateToProps, { deleteAnswer, editAnswer })(AnswerItem);
